import { Injectable, Injector } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { Client } from 'core/models/client';
import { HttpDataService } from './http-data.service';
import { ConfigurationsService } from './configurations.service';

@Injectable()
export class ClientsService extends HttpDataService {
  constructor(protected injector: Injector, public configurationsService: ConfigurationsService) {
    super(injector, '/core/clients');
  }

  getClient(id: string): Observable<Client> {
    return super.getItem(id);
  }

  create(props: any): Promise<Client> {
    return super.create(props);
  }

  update(client: Client, getActiveData: boolean = false): Promise<Client> {
    return super.update(client, { getActiveData });
  }

  deleteClientAccountData(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}/account-data`;
    return this.deleteRequest(url, this.getRequestOptions());
  }

  getClientSubscriptionType(clientId: string): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/subscriptionType/${clientId}`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  getClientAccountDetails(clientId: string): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/${clientId}/account-details`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
}
